import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { HearingsApiService } from 'src/app/core/services/api/hearings-api.service';
import { PostponeCloseCause } from '../../models/hearings/postponeCloseCause';

@Component({
  selector: 'app-case-postpone-create-edit',
  templateUrl: './case-postpone-create-edit.component.html',
  styleUrls: ['./case-postpone-create-edit.component.scss']
})
export class CasePostponeCreateEditComponent implements OnInit {

  public casePostpone: PostponeCloseCause;

  @ViewChild('casePostponesModal') casePostponesModal;
  @Output() submit: EventEmitter<PostponeCloseCause> = new EventEmitter<PostponeCloseCause>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: HearingsApiService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(casePostpone: PostponeCloseCause) {
    this.casePostpone = Object.assign(new PostponeCloseCause(), casePostpone);
    this.modalRef = this.modalService.open(this.casePostponesModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.casePostpone.id) {
      this.spinner.show();
      this.api.updatePostponeCause(this.casePostpone).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createPostponeCause(this.casePostpone).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

}

